<template >
    <div class="hot-news-details">
        <bannerSearch></bannerSearch>
        <div class="news-details">
            <div class="tit">{{info.title}}</div>
            <div class="info">
                <div v-if='info.source'>
                    <p class="info-label">来源：</p>
                    <p class="info-value">{{info.source}}</p>
                </div>
                <div v-if='info.publishDate'>
                    <p class="info-label">发布时间：</p>
                    <p class="info-value">{{info.publishDate}}</p>
                </div>
                <div v-if='info.count'>
                    <p class="info-label">访问量：</p>
                    <p class="info-value">{{info.count}}</p>
                </div>
            </div>
            <div class="detail-info">
                <div v-html="info.content"></div>
                <div v-if="info.newsUrl" class="look-original">
                    <a :href="info.newsUrl" target="_blank">查看原文</a>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {hotNewsDetails} from '../io/api.js';
import bannerSearch from './comps/banner_search.vue';
export default {
    components:{
        bannerSearch,
    },
    data(){
        return {
            id:this.$route.query.id,
            info:{
                title :'',//标题
                content:'',//内容
                source:'',//来源
                cover:'',//封面
                summary:'',//摘要
                publishDate:'',//发布时间
                count:'',//浏览次数
                newsUrl:'',//新闻链接
            },
        }
    },
    mounted(){
        this.getHotNewsDetails();
    },
    methods:{
        getHotNewsDetails(){
            hotNewsDetails(this.id).then(res=>{ 
                let {code,data,msg} = res.data;
                if(code==0){
                    this.info=data;
                }else{
                    this.$message.error(msg||'请求失败～')
                }
            })
        }
    }
}
</script>
<style lang="less" >
.hot-news-details{
    .news-details{
        width: 1200px;
        margin: 40px auto;
    }
    .tit{
        font-size: 24px;
        font-weight: bold;
        margin-bottom: 20px;
        text-align: center;
    }
    .info{
        display: flex;  
        justify-content: center;
        line-height: 28px;
        margin-bottom: 10px;
        >div{
            display: flex;
            align-items: center;
            margin: 0 20px ;
        }
        .info-label{ 
            text-align: right;
            font-weight: bold;
        }
        .info-value{ 
            color: #999999;
        }
    }
    .detail-info{
        padding: 20px; 
        margin-top: 30px;
        box-shadow: 0px 3px 12px 0px #c4bfbc;
        border-radius: 10px;
        >div{
            line-height: 28px;  
            text-indent: 2em;  
            div,p{
                margin: 10px 0;;
            }
        }
        .look-original{
            text-align: right;
            a{
                display: block;
                color: #396de7;
                font-size: 16px;
                &:hover{
                    text-decoration: underline;
                }
            }
        }  
    }
}
</style>